import RisIndex from "./RISIndex";
import RisIndexLocationSearchFunctionResult from "./RisIndexLocationSearchFunctionResult";

export default class RisIndexLocationSearchResult {
    public results: RisIndex[] = null;
    public totalNumberOfResults: number = null;
    public numberOfResultsPerFunction: RisIndexLocationSearchFunctionResult[] = null;

    constructor() {
        this.results = [];
        this.totalNumberOfResults = 0;
        this.numberOfResultsPerFunction = [];
    }
}